export default __webpack_public_path__ + "static/media/sho5.c76fd6f1.jpg";